import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInJumpStartExperiment() {
  return useIsInExperiment('car-merch-ui-vdp-jump-start-v2', 'treatment');
}
